import template from './insuranceAllocatedAdviser.html';
import controller from './insuranceAllocatedAdviserCtrl.js';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    onSelectAdivser: '&',
  },
};
